import c_cover from "../src/js/fun/extends";
import throttle, { Throttle } from "../src/js/fun/threttle/throttle2";
export { throttle, Throttle, c_cover };
